import { useState, useMemo } from 'react'
import { useQuery } from 'react-query'
import axios from 'axios'
import { format } from 'date-fns'

const formatDate = (dateString) => {
  if (!dateString) return ''
  try {
    const [year, month, day] = dateString.split('/')
    const date = new Date(year, month - 1, day)
    return format(date, 'dd/MM/yyyy')
  } catch (e) {
    return dateString
  }
}

// Helper para verificar si es el mismo día
// const sameDay = (d1, d2) => isSameDay(d1, d2)

const useScheduleOptions = (branchId = 36) => {
  const [selectedDate, setSelectedDate] = useState('')
  const [selectedTime, setSelectedTime] = useState('')

  const { data: scheduleResponse, isLoading: isLoadingSchedule } = useQuery(
    ['scheduleOptions', branchId],
    async () => {
      const req = await axios.get(
        `https://api.clikauto.com/api/inspection_options/${branchId}/schedule`,
      )
      return req.data
    },
    {
      refetchOnWindowFocus: false,
    },
  )

  // Extraemos el arreglo de horarios, manejando diferentes estructuras de respuesta
  const scheduleData = useMemo(() => {
    if (!scheduleResponse) return []
    // Si la API devuelve el arreglo directamente
    if (Array.isArray(scheduleResponse)) return scheduleResponse
    // Si la API devuelve un objeto con la propiedad regular_schedule
    if (scheduleResponse.regular_schedule && Array.isArray(scheduleResponse.regular_schedule)) {
      return scheduleResponse.regular_schedule
    }
    return []
  }, [scheduleResponse])

  // Extraemos y filtramos los días (igual que en tu ejemplo funcional)
  const availableDates = useMemo(() => {
    if (!scheduleData.length) return []

    return scheduleData
      .filter((item) => item.hours && item.hours.length > 0) // Que tengan horas
      // Opcional: Filtrar si es el mismo día (descomenta si lo necesitas)
      // .filter((item) => {
      //   const itemDate = new Date(item.week_day.split('/').join('-'))
      //   return !sameDay(new Date(), itemDate)
      // })
      .map((option) => ({
        value: option.week_day,
        label: formatDate(option.week_day),
      }))
  }, [scheduleData])

  // Extraemos las horas del día seleccionado
  const availableHours = useMemo(() => {
    if (!selectedDate || !scheduleData.length) return []

    const dayData = scheduleData.find((day) => day.week_day === selectedDate)
    return dayData ? dayData.hours : []
  }, [scheduleData, selectedDate])

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value)
    setSelectedTime('') // Resetea la hora al cambiar de día
  }

  const handleTimeChange = (event) => {
    setSelectedTime(event.target.value)
  }

  return {
    options: {
      dates: availableDates, // Ahora es un arreglo de objetos { value, label }
      hours: availableHours,
    },
    values: {
      selectedDate,
      selectedTime,
    },
    handlers: {
      handleDateChange,
      handleTimeChange,
    },
    status: {
      isLoadingSchedule,
    },
  }
}

export default useScheduleOptions
